const OAUTH_BASE = 'https://accounts.google.com/o/oauth2/v2/auth';

function buildOAuthUrl(params: {
  scopes: string;
  redirectUri: string;
  state?: string;
}): string {
  const searchParams = new URLSearchParams({
    client_id: import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID,
    redirect_uri: 'http://127.0.0.1:3000/auth/',
    response_type: 'code',
    scope: params.scopes,
    access_type: 'offline',
    prompt: 'consent',
  });

  if (params.state) {
    searchParams.set('state', params.state);
  }

  return `${OAUTH_BASE}?${searchParams.toString()}`;
}

/**
 * Redirect the user to Google OAuth for sign-in.
 * After consent, Google redirects back with ?code=...&state=...
 */
export function startGoogleSignIn(): void {
  const redirectUri = `${window.location.origin}/auth/`;
  const url = buildOAuthUrl({
    scopes: "openid email profile",
    redirectUri,
    state: 'signin',
  });
  window.location.href = url;
}

/**
 * Redirect the user to Google OAuth for email sync (Gmail read access).
 * Requests the gmail.readonly scope in addition to basic profile scopes.
 */
export function startGoogleEmailSync(): void {
  const redirectUri = `${window.location.origin}/auth/`;
  const url = buildOAuthUrl({
    scopes: "openid email profile https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/gmail.readonly",
    redirectUri,
    state: 'email-sync',
  });
  window.location.href = url;
}

/**
 * Parse the OAuth callback URL for the authorization code and state.
 */
export function parseOAuthCallback(search: string): {code: string | null; state: string | null} {
  console.log("PARSE")
  const params = new URLSearchParams(search);
  return {
    code: params.get('code'),
    state: params.get('state'),
  };
}
